import { render } from "./Note.vue?vue&type=template&id=b53ea08a"
import script from "./Note.vue?vue&type=script&lang=js"
export * from "./Note.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/rizome.dvit.cloud/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__